import { collaborationApi } from "@/api";
import { awsSqsConfig } from "@/api/apps.config";
import { collaborationMqttService } from "@/store/services";

const proConfig = awsSqsConfig.pro
const AccessKeyId = proConfig.AccessKeyId
const SecretKey = proConfig.SecretKey
const credentials = {
  accessKeyId: AccessKeyId,
  secretAccessKey: SecretKey,
};
let ReceiveMessageCommand,DeleteMessageCommand;

export default class CollaborationAwsSqsService {
  constructor() {
    this.sqsClient = null
    this.onMsgInterval = null
    this.regin = null;
  }
  initial(REGION) {
    this.region = REGION
    //this.sqsClient = new SQSClient({ region: REGION, credentials: credentials });
  }
  messageHandler(data) {
    const { reviewSessionID } = data
    const topic = `shareReview/${reviewSessionID}`
    const message = JSON.stringify(data)

    collaborationMqttService.handler({topic, message})
  }
  async onMessage({reviewSessionID}) {
    if(!this.sqsClient){
      const sqsModule = await import("@aws-sdk/client-sqs")

      let {SQSClient} = sqsModule;
      ReceiveMessageCommand = sqsModule.ReceiveMessageCommand;
      DeleteMessageCommand = sqsModule.DeleteMessageCommand;

      this.sqsClient = new SQSClient({ region: this.region, credentials: credentials });
    }
    try {
      const queueUrlRes = await collaborationApi.getShareReviewQueueUrl(reviewSessionID)
  
      if (queueUrlRes.ret !== 0) {
        throw 'get queue url error'
      }

      const QueueUrl = queueUrlRes.data.queueUrl
      const params = {
        AttributeNames: ["SentTimestamp"],
        MaxNumberOfMessages: 1,
        MessageAttributeNames: ["All"],
        QueueUrl,
        VisibilityTimeout: 20,
        WaitTimeSeconds: 10,
      };
  
      if (!this.onMsgInterval) {
        this.onMsgInterval = setInterval(async () => {
          const sqsClient = this.sqsClient
          const receiveData = await sqsClient.send(new ReceiveMessageCommand(params));
      
          if (receiveData.Messages) {
            const receiveMsg = receiveData.Messages[0]
            const jsonData = receiveMsg.Body
            const data = jsonData && JSON.parse(jsonData)
            const message = JSON.parse(data.Message)
  
            this.messageHandler(message)
    
            const deleteParams = {
              QueueUrl,
              ReceiptHandle: receiveMsg.ReceiptHandle,
            };
      
            await sqsClient.send(new DeleteMessageCommand(deleteParams));
      
          } else {
            console.log("No messages to delete");
          }
          
        }, 10000);
      }
    } catch (error) {
      console.error(error);
    }
  }
  cleanOnMsgInterval() {
    if (this.onMsgInterval) {
      clearInterval(this.onMsgInterval)
      this.onMsgInterval = null
    }
  }
}